module.exports = __webpack_public_path__ + "static/media/shareBg.1f879cb3.png";